(function ($) {
	$.fn.ndGallery = function (args) {
		return this.each(function () {
			var $me = $(this);

			var slideOn = $me.data('slide-on');
			if(typeof slideOn !== 'undefined') {
				if(slideOn.split(',').indexOf(pxco.breakpoints.value) == -1)
				  return false;
			}

			var settings = $.extend({
				timeout: 6000,
				speed: 500,
				controls: true,
				pager: true,
				autoHeight: true,
				sync: false,
				fullscreen: false,
				options: {}
			}, args);

			var mainOptions = {
				slides: '> li',
				controls: typeof $me.data('controls') !== 'undefined' ? $me.data('controls') : settings.controls,
				timeout: typeof $me.data('timeout') !== 'undefined' ? $me.data('timeout') : settings.timeout,
				speed: typeof $me.data('speed') !== 'undefined' ? $me.data('speed') : settings.speed
			};

			var fx = $me.data('fx'),
				fxBreakpoint = $me.data('fx-on');

			function setFx() {
				if(fxBreakpoint && fxBreakpoint !== pxco.breakpoints.value)
					return false;
				
				mainOptions.fx = fx;

				if(fx == 'carousel') {
					settings.autoHeight = false;
					mainOptions.timeout = 0;
					mainOptions.carouselVisible = $me.data('carousel-visible') ? $me.data('carousel-visible') : 4;
					mainOptions.carouselVertical = $me.data('carousel-vertical') ? $me.data('carousel-vertical') : false;
					mainOptions.carouselFluid = $me.data('carousel-vertical') ? false : true;
				}
			}

			if(fx)
				setFx();

			var $slider = $me.find('.cycle-slides'),
				$prevControl = $('<a href="#" class="cycle-control cycle-prev icon-left"></a>'),
				$nextControl = $('<a href="#" class="cycle-control cycle-next icon-right"></a>');

			if (settings.pager || settings.controls) 
				$me.append('<div class="cycle-controls"></div>');

			// add pager
			if (settings.pager) {
				if ($me.find('.cycle-pager').length == 0)
					$me.find('.cycle-controls').append('<ul class="cycle-pager"></ul>');
				mainOptions.pager = '~ .cycle-controls .cycle-pager',
				mainOptions.pagerTemplate = '<li><a href="#"></a></li>';
			}

			// add controls
			if (mainOptions.controls) {
				if ($me.find('.cycle-control').length == 0)
					$me.find('.cycle-controls').append($prevControl.add($nextControl));
				mainOptions.prev = '~ .cycle-controls .cycle-prev';
				mainOptions.next = '~ .cycle-controls .cycle-next';
			}

			if (settings.autoHeight)
				mainOptions.autoHeight = 'container'

			$.extend(mainOptions, settings.options);
			
			$slider.cycle(mainOptions);

			$me.addClass('active');

			if(settings.fullscreen) {
				$(document).on('keyup', function(e) {
					var code = e.keyCode || e.which;

					if($me.is('.active') && code == 27) {
						$me.find('.cycle-slides').cycle('destroy');
						$me.remove();
					}
				});
			}
		});
	};

	$(document).ready(function() {
		$('[data-slideshow]').ndGallery();
	});

	$('[data-gallery-open] a').on('click', function (e) {
		e.preventDefault();

		var $source = $(this).closest('[data-gallery-open]'),
			$container = $('<ul></ul>'),
			srcRef = $(this).attr('href');

		var slides = $source.find('li').clone();

		if(typeof $source.data('cycle.opts') !== 'undefined')
			slides = $source.data('cycle.opts').slides.clone();

		$container.append(slides);
		$container.attr('class', 'cycle-slides');
		$container.find('img').each(function () {
			var imgFull = $(this).parent('a').attr('href');
			$(this).removeAttr('width').removeAttr('height');
			$(this).unwrap('a').attr('src', imgFull);
		});

		$container.wrap('<div class="gallery" data-slideshow="fullscreen"></div>')
			.after('<a href="#" class="gallery_close" data-gallery-close>&times;</a>')
			.parent().appendTo('body');

		var index = $container.find('[src="' + srcRef + '"]').parent('li').index();
		
		$('[data-slideshow="fullscreen"]').ndGallery({
			timeout: 0,
			autoHeight: false,
			pager: false,
			fullscreen: true,
			options: {
				startingSlide: index
			}
		}).addClass('active');

		$('[data-gallery-close]').on('click', function (e) {
			e.preventDefault();
			$(this).parent('.cycle-slides').cycle('destroy');
			$(this).parent('.gallery').remove();
		});
	});
})(jQuery);